export const GET_USERS          = 'GET_USERS';
export const GET_USERS_SUCCESS  = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL     = 'GET_USERS_FAIL';

export const INIT_USERS          = 'INIT_USERS';
export const INIT_USERS_SUCCESS  = 'INIT_USERS_SUCCESS';
export const INIT_USERS_FAIL     = 'INIT_USERS_FAIL';

export const CLEAR_USERS        = 'CLEAR_USERS';